import React from "react";
import { connect } from "react-redux";

import Dialog from "../../components/dialog/Dialog";
import DialogCancel from "../../components/dialog/DialogCancel";
import DialogContent from "../../components/dialog/DialogContent";
import DialogFooter from "../../components/dialog/DialogFooter";
import { moveNextFileExplorer } from "../../state/system/FileExplorers";
import { IAppState } from "../../state/Store";
import DialogOK from "../../components/dialog/DialogOK";
import FileExplorer from "./FileExplorer";
import FileExplorerEntry, { FileExplorerTypes } from "../../types/system/FileExplorer";
import File from "../../types/files/File";

interface FileExplorerDialogProps {
    open: boolean;
    current: FileExplorerEntry;
    status: string;
        
    moveNextFileExplorer: (selected: File) => void;
}

interface FileExplorerDialogState {
    selected: File; 
}

class FileExplorerDialog extends React.Component<
    FileExplorerDialogProps,
    FileExplorerDialogState
> {
    state = {
        selected: null,
    } as FileExplorerDialogState;

    okClick() {
        this.props.moveNextFileExplorer(this.state.selected);
    }

    cancelClick() {
        this.props.moveNextFileExplorer(null);
    }

    itemClicked(item: File) {
        this.setState(() => ({ selected: item }));
    }

    render() {
        return (
            <Dialog
                dialogTitle={this.props.current?.title ?? "File Explorer"}
                showDialog={this.props.open}
                showLoading={this.props.status === "loading"}
                zIndex={997}>
                <DialogContent>
                    {this.props.open && (
                        <FileExplorer
                            type={this.props.current?.type ?? FileExplorerTypes.Any}
                            value={this.state.selected}
                            denyUpload={this.props.current?.denyUpload}
                            onChange={item => this.itemClicked(item)}
                        />
                    )}
                </DialogContent>
                <DialogFooter>
                    <DialogOK
                        disabled={!this.state.selected}
                        onClick={() => this.okClick()}
                    />
                    <DialogCancel onClick={() => this.cancelClick()} />
                </DialogFooter>
            </Dialog>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { fileExplorer, folders } = state.db;
    return {
        open: fileExplorer.open,
        current: fileExplorer.current,
        status: folders.allStructureStatus,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        moveNextFileExplorer: (selected: File) => dispatch(moveNextFileExplorer(selected)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FileExplorerDialog);
